var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { attrs: { "aria-label": "Site menu" } },
    [
      _c("slide-in-overlay", {
        staticClass: "c-sitemenu",
        attrs: { "is-open": _vm.isOpen },
        on: { close: _vm.close },
        scopedSlots: _vm._u(
          [
            {
              key: "tools",
              fn: function() {
                return [_vm._t("tools")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "c-sitemenu__toolbar c-sitemenu__toolbar--pull"
                    },
                    [
                      _c("div", { staticClass: "heading" }, [
                        _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.translations["Language and currency"]
                              ) +
                              " :\n                    "
                          )
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.siteName) +
                            " / " +
                            _vm._s(_vm.selectedCurrency) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "o-btn o-btn--transparent o-btn--small",
                          on: {
                            click: function($event) {
                              _vm.showSelector = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.translations["Change"]) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slideleft" } }, [
                    _vm.showSelector
                      ? _c("div", { staticClass: "c-sitemenu__selector" }, [
                          _c("div", { staticClass: "c-sitemenu__toolbar" }, [
                            _c("div", { staticClass: "heading" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.translations["Language and currency"]
                                  ) +
                                  ":\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "o-btn o-btn--small",
                                on: {
                                  click: function($event) {
                                    return _vm.updateSite()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.translations["Save choises"]) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "\n                            c-sitemenu__heading c-sitemenu__heading--push\n                        "
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.translations["Currency"]) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-sitemenu__list" },
                            _vm._l(_vm.currencies, function(currency) {
                              return _c(
                                "label",
                                {
                                  key: currency.id,
                                  staticClass: "c-sitemenu__listItem",
                                  attrs: { for: currency.iso }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedCurrency,
                                        expression: "selectedCurrency"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: currency.alphabeticCode,
                                      name: "currency"
                                    },
                                    domProps: {
                                      value: currency.alphabeticCode,
                                      checked: _vm._q(
                                        _vm.selectedCurrency,
                                        currency.alphabeticCode
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.selectedCurrency =
                                          currency.alphabeticCode
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.translations[currency.currency]
                                        ) +
                                        " (" +
                                        _vm._s(currency.alphabeticCode) +
                                        ")\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "checkmark" }, [
                                    _c("img", {
                                      attrs: { src: "/images/checkmark.svg" }
                                    })
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._t("productmenu")
                ]
              },
              proxy: true
            },
            {
              key: "secondaryBody",
              fn: function() {
                return [_vm._t("sitemenu")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }